module.exports = __webpack_public_path__ + "df287fdaa36121cd65c2282e470e6f7a.png";